// トースト通知。成功通知(例:「変更を保存しました」)用の軽量な一時表示。
// module-level の singleton state(useModal / useLock と同方針)。SPA(ssr:false)前提。
import { readonly, ref } from 'vue'

/** 自動的に消えるまでのミリ秒(モック準拠 3 秒)。 */
export const TOAST_AUTO_HIDE_MS = 3000

type ToastType = 'info' | 'attention' | 'error'

const message = ref('')
const visible = ref(false)
const duration = ref(TOAST_AUTO_HIDE_MS)
const type = ref<ToastType>('info')
const seq = ref(0) // show() ごとに増やし、ToastView の :key に使って再マウントさせる
let timer: ReturnType<typeof setTimeout> | undefined

const hide = () => {
  visible.value = false
  if (timer) {
    clearTimeout(timer)
    timer = undefined
  }
}

/** メッセージを表示し、durationMs 後に自動で隠す。連続呼び出しは前のタイマーを破棄。 */
const show = (msg: string, durationMs = TOAST_AUTO_HIDE_MS, toastType: ToastType = 'info') => {
  message.value = msg
  duration.value = durationMs
  type.value = toastType
  seq.value++
  visible.value = true
  if (timer) {
    clearTimeout(timer)
    timer = undefined
  }
  timer = setTimeout(hide, durationMs)
}

export const useToast = () => {
  return {
    message: readonly(message),
    visible: readonly(visible),
    duration: readonly(duration),
    type: readonly(type),
    seq: readonly(seq),
    show,
    hide,
  }
}
